import api from './api';

export interface PendingConsent {
  client: {
    clientId: string;
    name: string;
    description: string | null;
  };
  redirectUri: string;
  scopes: { name: string; description: string }[];
  expiresInSeconds: number;
}

export interface ConsentResponse {
  redirectUrl: string;
}

export async function getPendingConsent(handle: string): Promise<PendingConsent> {
  const response = await api.get<PendingConsent>('/oauth/pending-consent', {
    params: { ch: handle },
  });
  return response.data;
}

export async function submitConsent(handle: string, decision: 'allow' | 'deny'): Promise<ConsentResponse> {
  const response = await api.post<ConsentResponse>('/oauth/authorize/consent', {
    ch: handle,
    decision,
  });
  return response.data;
}
